'use strict';
const utils = require('./utilsFunctions')

module.exports = {

    //pmt: float
    //i: float
    //n: int
    //return: float.toFixed(2) 2 casas decimais
    valorPresente(vlr, i, n) {
        return (vlr / (1 + (i / 100)) * (1 - Math.pow(1 + (i / 100), -n))).toFixed(2)
    },
    //pv: float
    //i: float
    //n: int
    //pmt: float
    //return: float.toFixed(2) 2 casas decimais
    valorFuturo(pv, i, n, pmt) {
        if (n === 0) n = 1
        let pow = Math.pow(1 + (i / 100), n)
        return ((pmt * (1 + (i / 100) * 0) * (1 - pow) / (i / 100)) - pv * pow).toFixed(2) * (-1)
    },
    //pv: float
    //i: float
    //n: int
    //return: float.toFixed(2) 2 casas decimais
    pgto(pv, i, n) {
        if (n === 0) n = 1
        return (pv * (i / 100) * Math.pow(1 + (i / 100), n) / (Math.pow(1 + (i / 100), n) - 1)).toFixed(2)
    },
    pgtoMaisFuturo(pv, i, n, tem13o) {
        let vlr13o = 0
        if (tem13o) {
            vlr13o = ((1 - (Math.pow(1 + (i / 100), -(n / 12)))) / (i / 100))
        }
        let ret = pv * (1 / (((1 - (Math.pow((1 + (Math.pow((1 + (i / 100)), (1 / 12)) - 1)), (-n)))) / (Math.pow((1 + (i / 100)), (1 / 12)) - 1)) + vlr13o))
        return ret.toFixed(2)

    },
    pgtoComPv(i, n, pv, fv, type) {
        var pmt, pvif;

        fv || (fv = 0);
        type || (type = 0);

        n = Number(n)
        pv = parseFloat(pv)
        fv = parseFloat(fv)
        i = parseFloat(i)

        if (n === 0) n = 1
        if (i === 0) return -(pv + fv) / n;

        pvif = Math.pow(1 + (i / 100), n);
        //console.log('===> n', n, '- i', i, ' - pv', pv, ' - pvif', pvif, ' - fv', fv )
        pmt = (i / 100) / (pvif - 1) * -(pv * pvif + fv);
        //pmt = i * pv * (pvif + fv) / (pvif - 1);

        if (type === 1)
            pmt /= (1 + (i / 100));

        return (pmt * -1);
    },
    pgtoIpmt(pv, pmt, i, per) {

        i = i / 100
        let tmp = Math.pow(1 + i, per - 1)
        return ((pv * tmp * i) - (pmt * (tmp - 1)));
    },
    pgtoComPvDetalhado(pv, i, per, nper, fv, type) {
        if (per < 1 || (per >= nper + 1)) return null;
        var pmt = this.pgtoComPv(i, nper, pv, fv, type)
        var ipmt = this.pgtoIpmt(pv, pmt, i, per);
        return {
            principal: pmt - ipmt,
            juros: ipmt,
            total: pmt
        }
    },
    calculaLimiteLiquidoEmprestimo(valorTotalBrutoPreAprovado, valorSaldoRemanescente, objRegrasModalidadeEmprestimo, dataLiberacao) {

        //atualiza SaldoRemanescente até a data da liberação
        let dataPrimeiroDiaMesLiberacao = new Date(dataLiberacao.getFullYear(), dataLiberacao.getMonth(), 1); //ultimo dia do mês da data de liberação
        valorSaldoRemanescente = this.calculaProRata(valorSaldoRemanescente, dataPrimeiroDiaMesLiberacao, dataLiberacao, (objRegrasModalidadeEmprestimo.taxaJuros + 1)) //Soma mais 1% para correção montetária conservadora (ainda não temos no portal tabela de índice de correção)

        let retParcelas = this.calculaParcelasEmprestimo(valorTotalBrutoPreAprovado, objRegrasModalidadeEmprestimo.qtdParcelasEntradaSimulador, dataLiberacao, objRegrasModalidadeEmprestimo)
        let valorTaxaAdm = valorTotalBrutoPreAprovado * objRegrasModalidadeEmprestimo.taxaAdm / 100
        let valorTaxaFundoRisco = valorTotalBrutoPreAprovado * objRegrasModalidadeEmprestimo.taxaFundoRisco / 100
        let valorTaxaIofAdicional = valorTotalBrutoPreAprovado * objRegrasModalidadeEmprestimo.taxaIofAdicional / 100
        //let valorLiquidoFinalPreAprovado = valorTotalBrutoPreAprovado - retParcelas.valorTotalJuros - valorTaxaAdm - valorTaxaFundoRisco - retParcelas.valorTotalIof - valorTaxaIofAdicional
        let valorLiquidoFinalPreAprovado = valorTotalBrutoPreAprovado - valorTaxaAdm - valorTaxaFundoRisco - retParcelas.valorTotalIof - valorTaxaIofAdicional
        valorLiquidoFinalPreAprovado = valorLiquidoFinalPreAprovado - valorSaldoRemanescente

        return valorLiquidoFinalPreAprovado > 0 ? valorLiquidoFinalPreAprovado : 0
    },
    calculaTotalBrutoEmprestimo(valorLiquidoDesejado, valorSaldoRemanescente, qtdParcelas, dataLiberacao, objRegrasModalidadeEmprestimo) {

        //atualiza SaldoRemanescente até a data da liberação
        let dataPrimeiroDiaMesLiberacao = new Date(dataLiberacao.getFullYear(), dataLiberacao.getMonth(), 1); //ultimo dia do mês da data de liberação
        valorSaldoRemanescente = this.calculaProRata(valorSaldoRemanescente, dataPrimeiroDiaMesLiberacao, dataLiberacao, (objRegrasModalidadeEmprestimo.taxaJuros + 1))  //Soma mais 1% para correção montetária conservadora (ainda não temos no portal tabela de índice de correção)


        //valorSaldoRemanescente = 44361.43

        let valorTotalOperacao = valorLiquidoDesejado + valorSaldoRemanescente
        let valorBaseCalculo
        //PASSO 1:
        //primeiro, para calcular a taxa total do Iof simula um empréstimo com o valor solicitado (liquido mesmo) ou o valor do empréstimo anterior caso exista
        if (valorSaldoRemanescente > 0) {
            valorBaseCalculo = valorSaldoRemanescente
        } else {
            valorBaseCalculo = valorLiquidoDesejado
        }

        let retParcelasAux = this.calculaParcelasEmprestimo(valorBaseCalculo, qtdParcelas, dataLiberacao, objRegrasModalidadeEmprestimo)
        let taxaTotalIof = retParcelasAux.valorTotalIof / valorBaseCalculo
        let percTotalTaxas = 1 - (taxaTotalIof + (objRegrasModalidadeEmprestimo.taxaAdm / 100) + (objRegrasModalidadeEmprestimo.taxaFundoRisco / 100) + (objRegrasModalidadeEmprestimo.taxaIofAdicional / 100))

        //atualiza valor bruto na proporção encontrada
        let valorTotalBruto
        if (valorSaldoRemanescente > 0) {
            let valorTaxaAdmRemanescente = valorSaldoRemanescente * objRegrasModalidadeEmprestimo.taxaAdm / 100
            let valorTaxaFundoRiscoRemanescente = valorSaldoRemanescente * objRegrasModalidadeEmprestimo.taxaFundoRisco / 100
            let valorTaxaIofAdicionalRemanescente = valorSaldoRemanescente * objRegrasModalidadeEmprestimo.taxaIofAdicional / 100
            let valorTaxaIofRemanescente = retParcelasAux.valorTotalIof

            valorTotalBruto = (valorTotalOperacao -
                valorTaxaAdmRemanescente -
                valorTaxaFundoRiscoRemanescente -
                valorTaxaIofAdicionalRemanescente -
                valorTaxaIofRemanescente)
                / percTotalTaxas
        } else {
            valorTotalBruto = valorTotalOperacao / percTotalTaxas
        }

        //PASSO 2:
        //recalcular as parcelas de empréstimo com o NOVO valor Total Bruto
        let retParcelas = this.calculaParcelasEmprestimo(valorTotalBruto, qtdParcelas, dataLiberacao, objRegrasModalidadeEmprestimo)

        let valorTaxaAdm = (valorTotalBruto) * objRegrasModalidadeEmprestimo.taxaAdm / 100
        let valorTaxaFundoRisco = (valorTotalBruto) * objRegrasModalidadeEmprestimo.taxaFundoRisco / 100
        let valorTaxaIofAdicional = (valorTotalBruto) * objRegrasModalidadeEmprestimo.taxaIofAdicional / 100

        //PASSO 3:
        //ajustar valor Bruto e os valores das taxas excluindo valores de taxas já pagas pelo participante
        if (valorSaldoRemanescente > 0) {
            let valorTaxaAdmRemanescente = valorSaldoRemanescente * objRegrasModalidadeEmprestimo.taxaAdm / 100
            let valorTaxaFundoRiscoRemanescente = valorSaldoRemanescente * objRegrasModalidadeEmprestimo.taxaFundoRisco / 100
            let valorTaxaIofAdicionalRemanescente = valorSaldoRemanescente * objRegrasModalidadeEmprestimo.taxaIofAdicional / 100
            let valorTaxaIofRemanescente = retParcelasAux.valorTotalIof

            valorTaxaAdm -= valorTaxaAdmRemanescente
            valorTaxaFundoRisco -= valorTaxaFundoRiscoRemanescente
            valorTaxaIofAdicional -= valorTaxaIofAdicionalRemanescente
            retParcelas.valorTotalIof -= valorTaxaIofRemanescente
        }

        let valorLiquidoFinal = valorTotalBruto - valorTaxaAdm - valorTaxaFundoRisco - retParcelas.valorTotalIof - valorTaxaIofAdicional

        return {
            valorTotalBruto: valorTotalBruto,
            valorTotalOperacao: valorTotalOperacao,
            valorLiquidoFinal: valorLiquidoFinal,
            custos: {
                valorJuros: retParcelas.valorTotalJuros,
                valorTaxaAdm: valorTaxaAdm,
                valorTaxaFundoRisco: valorTaxaFundoRisco,
                valorTaxaIof: retParcelas.valorTotalIof,
                valorTaxaIofAdicional: valorTaxaIofAdicional,
                valorSaldoRemanescente: valorSaldoRemanescente
            },
            parcelas: retParcelas.parcelas
        }
    },
    calculaParcelasEmprestimo(valorTotal, qtdParcelas, dataLiberacao, objRegrasModalidadeEmprestimo) {
        let arrayParcelas = [], diffDias = 0, dataVencimentoNoMes, pgtoDetalhado, valorTotalIof = 0, valorTotalJuros = 0
        let dataUltimoDiaMesLiberacao = new Date(dataLiberacao.getFullYear(), dataLiberacao.getMonth() + 1, 0); //ultimo dia do mês da data de liberação

        //calcula valor do principal considerando o prorata até o final do mês da solicitação
        let valorPrincipalDevedor = this.calculaProRata(valorTotal, dataLiberacao, dataUltimoDiaMesLiberacao, (objRegrasModalidadeEmprestimo.taxaJuros) + 1) //Soma mais 1% para correção montetária conservadora (ainda não temos no portal tabela de índice de correção)

        let valorSaldoDevedor = valorPrincipalDevedor
        let dataAux = dataLiberacao
        let valorIofParcela

        //salva na primeira posição o valor do empréstimo corrigido até o final do mês da solicitação
        arrayParcelas.push({ nParcela: 0, vencimento: dataUltimoDiaMesLiberacao, principal: 0, juros: 0, iof: 0, saldoDevedor: valorPrincipalDevedor })

        for (let m = 1; m <= qtdParcelas; m++) {

            dataVencimentoNoMes = new Date(dataAux.getFullYear(), dataAux.getMonth() + 1, objRegrasModalidadeEmprestimo.diaVencimento);
            if (dataVencimentoNoMes.getDate() !== objRegrasModalidadeEmprestimo.diaVencimento) { //indica que o dia de vencimento pode ser um 31 e o mês tem 30 dias ou menos
                dataVencimentoNoMes = new Date(dataAux.getFullYear(), dataAux.getMonth() + 2, 0);
            }

            //calculo do IOF
            diffDias = utils.diffDatasEmDias(dataLiberacao, dataVencimentoNoMes) + 1
            if (diffDias > objRegrasModalidadeEmprestimo.qtdDiasMaximoIof) {//na data deste DEV: legislação rege 365 dias...
                diffDias = objRegrasModalidadeEmprestimo.qtdDiasMaximoIof
            }

            //valor da parcela efetiva do empréstimo
            pgtoDetalhado = this.pgtoComPvDetalhado(valorPrincipalDevedor, objRegrasModalidadeEmprestimo.taxaJuros, m, qtdParcelas, 0, 0)

            valorSaldoDevedor = valorSaldoDevedor - pgtoDetalhado.principal

            valorIofParcela = (pgtoDetalhado.principal) * (objRegrasModalidadeEmprestimo.taxaIof / 100 * diffDias)
            //salva na primeira posição o valor do empréstimo corrigido até o final do mês da solicitação
            arrayParcelas.push({
                nParcela: m,
                vencimento: dataVencimentoNoMes,
                total: pgtoDetalhado.principal + pgtoDetalhado.juros,
                principal: pgtoDetalhado.principal,
                juros: pgtoDetalhado.juros,
                iof: valorIofParcela,
                saldoDevedor: valorSaldoDevedor
            })

            valorTotalIof += valorIofParcela
            valorTotalJuros += pgtoDetalhado.juros

            dataAux = dataVencimentoNoMes
        }

        return {
            parcelas: arrayParcelas,
            valorTotalIof: valorTotalIof,
            valorTotalJuros: valorTotalJuros
        }

    },
    valor_to_string_formatado(num, casasDecimais, incluiCifrao, fromWeb) {
        let numFormatado = parseFloat(parseFloat(num).toFixed(casasDecimais)) //arruma qqr forma que entrar
        if (incluiCifrao) {
            numFormatado = numFormatado.toLocaleString('pt-BR', { minimumFractionDigits: casasDecimais, maximumFractionDigits: casasDecimais, style: 'currency', currency: 'BRL' });
        } else {
            numFormatado = numFormatado.toLocaleString('pt-BR', { minimumFractionDigits: casasDecimais, maximumFractionDigits: casasDecimais });
        }
        if (!fromWeb) {
            numFormatado = numFormatado.replace(/,/g, '#')
            numFormatado = numFormatado.replace('.', ',')
            numFormatado = numFormatado.replace(/#/g, '.')
        }
        return numFormatado
    },
    calculaContribuicaoEsperada(aporteInicial, rendaEsperada, taxaAnual, tempoRecebimento, dataInicioRecebimento) {
        let qtdMeses = utils.diffDatasEmMeses(new Date(), dataInicioRecebimento)
        let taxaMensal = this.calculaTaxaMensal(taxaAnual)
        let reservaFutura = 0
        for (var i = 1; i <= tempoRecebimento; i++) {
            reservaFutura += rendaEsperada / Math.pow(1 + (4 / 100), i)
        }
        reservaFutura = reservaFutura - aporteInicial
        return this.pgtoComPv(taxaMensal, qtdMeses, 0, reservaFutura, 1).toFixed(2)
    },
    calculaContribuicaoMediaProjetada(valorFuturoProjetado, taxaAnual, qtdMeses) {
        let taxaMensal = this.calculaTaxaMensal(taxaAnual)

        return this.pgtoComPv(taxaMensal, qtdMeses, 0, parseFloat(valorFuturoProjetado)).toFixed(2)
    },
    calculaReservaFutura(reservaTotal, taxaAnual, contribParticipante, contribParticipantePlanoPatrocinado, contribPatronal, dataInicioRenda, tipoPlano, taxaCrescimentoContrib) {

        let reservaFutura, decimoTerceiro
        let qtdMeses = utils.diffDatasEmMeses(new Date(), dataInicioRenda)
        let taxaMensal = this.calculaTaxaMensal(taxaAnual)
        if (!taxaCrescimentoContrib || taxaCrescimentoContrib === 0) {
            reservaFutura = this.valorFuturo(
                reservaTotal,
                taxaMensal,
                qtdMeses,
                (contribParticipante + contribParticipantePlanoPatrocinado + contribPatronal).toFixed(2)
            )
            if (tipoPlano.toLowerCase() == 'jmalucelli' || tipoPlano.toLowerCase() == 'patrocinado') { // && !desconsidera13) { //se plano J projeta contribuições de 13o
                decimoTerceiro = this.valorFuturo(
                    0,
                    taxaAnual,
                    Math.trunc(qtdMeses / 12), //incluído por Leandro: garantir somente anos completos
                    (contribParticipantePlanoPatrocinado + contribPatronal).toFixed(2)
                )
                reservaFutura += decimoTerceiro
            }
        } else {
            taxaCrescimentoContrib = 1 + taxaCrescimentoContrib
            reservaFutura = reservaTotal
            let qtdMesesCalc = 0
            for (let i = 1; i <= qtdMeses; i++) {
                qtdMesesCalc++
                if (qtdMesesCalc === 12) {
                    reservaFutura = this.valorFuturo(
                        reservaFutura,
                        taxaMensal,
                        qtdMesesCalc,
                        (contribParticipante + contribParticipantePlanoPatrocinado + contribPatronal).toFixed(2)
                    )
                    if (tipoPlano.toLowerCase() == 'jmalucelli' || tipoPlano.toLowerCase() == 'patrocinado') {
                        //soma contribuição 13o
                        reservaFutura += contribParticipantePlanoPatrocinado + contribPatronal
                    }
                    qtdMesesCalc = 0
                    //aplica crescimento na contribuição
                    contribParticipante *= taxaCrescimentoContrib
                    contribParticipantePlanoPatrocinado *= taxaCrescimentoContrib
                    contribPatronal *= taxaCrescimentoContrib
                } else if (i === qtdMeses) { //último período
                    reservaFutura = this.valorFuturo(
                        reservaFutura,
                        taxaMensal,
                        qtdMesesCalc,
                        (contribParticipante + contribParticipantePlanoPatrocinado + contribPatronal).toFixed(2)
                    )
                }
            }
        }
        return reservaFutura.toFixed(2)
    },
    calculaRendaFutura(reservaTotalFutura, taxaAnual, qtdAnosRenda, tipoPlano) {
        let rendaMensal = this.pgtoMaisFuturo(reservaTotalFutura, taxaAnual, qtdAnosRenda * 12, tipoPlano === 'patrocinado')
        return rendaMensal
    },
    calculaContribProjetada(taxaAnual, qtdMesesAteHoje, reservaHoje, reservaTotalFutura) {
        let taxaMensal = this.calculaTaxaMensal(taxaAnual)
        let contribMensal = this.pgtoComPv(taxaMensal, qtdMesesAteHoje, reservaHoje, reservaTotalFutura, 1)
        return contribMensal
    },
    calculaTaxaMensal(taxaAnual) {
        return (Math.pow(taxaAnual / 100 + 1, 1 / 12) - 1) * 100
    },
    calculaDataInicioRenda(dataNasc, idadeApos) {
        // Garante que a data estará no formato dd/mm/aaaa
        dataNasc = utils.dateFormat(dataNasc, false, false, true)

        // Divide a data em partes
        let dateParts = dataNasc.split('/')

        // Cria a nova data somando a idade à parte do ano
        let ret = new Date(Number(dateParts[2]) + Number(idadeApos), dateParts[1] - 1, dateParts[0])

        // Se a data calculada for no passado, define a data atual
        if (ret < new Date()) {
            ret = new Date()
        }
        // Formata a data no padrão yyyy-mm-dd
        let dataFormatada = ret.toISOString().split('T')[0];

        return dataFormatada;
    },
    calculaIdadeApos(dataNasc, dataAdesao, idade) {
        let idadeNaAdesao = utils.diffDatasEmAnos(dataNasc, dataAdesao)
        let idadeApos = 65
        if (idadeNaAdesao > 55) {
            idadeApos = idadeNaAdesao + 10
        }
        if (idade > idadeApos) {
            idadeApos = idade
        }

        return idadeApos
    },
    calculaCrescimentoRealAnual(valorContribuicaoHoje, valorReservaHoje, qtdMesesDesdeAdesao) {
        let percCresc = valorReservaHoje / (valorContribuicaoHoje * qtdMesesDesdeAdesao)
        let percCrescAnualizado = (Math.pow(Math.pow(percCresc, (1 / qtdMesesDesdeAdesao)), 12) - 1) * 100
        return percCrescAnualizado < 0 ? 0 : percCrescAnualizado
    },
    valorFormatoDesc(num, fromWeb) {
        let ret = ''
        fromWeb = fromWeb || false
        if (Math.abs(num) > 999999) {
            ret = this.valor_to_string_formatado(Math.sign(num) * ((Math.abs(num) / 1000000)), 1, true, fromWeb)
            if (ret.indexOf(',0') >= 0) { //se o final do valor for ",0" retira...
                ret = this.valor_to_string_formatado(Math.sign(num) * ((Math.abs(num) / 1000000)), 0, true, fromWeb)
            }
            ret = ret + ' Mi'
        } else if (Math.abs(num) > 999) {
            ret = this.valor_to_string_formatado(Math.sign(num) * ((Math.abs(num) / 1000)), 1, true, fromWeb)
            if (ret.indexOf(',0') >= 0) { //se o final do valor for ",0" retira...
                ret = this.valor_to_string_formatado(Math.sign(num) * ((Math.abs(num) / 1000)), 0, true, fromWeb)
            }
            ret = ret + ' mil'
        } else {
            ret = this.valor_to_string_formatado(num, 2, true, fromWeb)
            if (ret.indexOf(',0') >= 0) { //se o final do valor for ",0" retira...
                ret = this.valor_to_string_formatado(num, 0, true, fromWeb)
            }
        }
        return ret
    },
    calculaContribuicaoProjetada(valorContribParticipanteAtual, valorContribParticipantePatrocAtual, situacaoPlano) {
        //information exist in db
        let taxaAumentoSugestao = 1.2
        let stepRenda = 50
        let valorDifContribProjetada = (valorContribParticipanteAtual + valorContribParticipantePatrocAtual) * (taxaAumentoSugestao - 1)
        let valorContribProjetada = 0
        let qtdStepsRenda = 1
        if (valorDifContribProjetada < stepRenda) {
            valorContribProjetada = valorContribParticipanteAtual + stepRenda
        } else {
            qtdStepsRenda = Math.trunc(valorDifContribProjetada / stepRenda)
            valorContribProjetada = valorContribParticipanteAtual + (stepRenda * qtdStepsRenda)
        }
        let ret = [this.valorFormatoDesc(valorContribProjetada - valorContribParticipanteAtual), valorContribProjetada, qtdStepsRenda]
        if (situacaoPlano === "Com Contribuição Suspensa") {
            ret = [0, valorContribParticipanteAtual + valorContribParticipantePatrocAtual, 0]
        }
        return ret
    },
    calculaCoberturaPotencial(coberturaMorte, coberturaInvalidez) {
        //information exist in db
        let taxaAumentoSugestao = 1.2
        let stepMorte = 10000
        let stepInvalidez = 10000
        let coberturaTotal = 0
        let dif, qtdSteps, qtdStepsValorAtual
        if (coberturaMorte + coberturaInvalidez === 0) {
            let vlr = 100000.00
            return [this.valorFormatoDesc(vlr), vlr]
        } else {
            if (coberturaMorte > 0) {
                dif = coberturaMorte * (1 - taxaAumentoSugestao)
                qtdStepsValorAtual = Math.trunc(coberturaMorte / stepMorte)
                if (dif < stepMorte) {
                    coberturaMorte = (qtdStepsValorAtual + 1) * stepMorte
                } else {
                    qtdSteps = Math.trunc(dif / stepMorte)
                    coberturaMorte = (qtdStepsValorAtual + qtdSteps + 1) * stepMorte
                }
            }
            if (coberturaInvalidez > 0) {
                dif = coberturaInvalidez * (1 - taxaAumentoSugestao)
                qtdStepsValorAtual = Math.trunc(coberturaInvalidez / stepInvalidez)
                if (dif < stepInvalidez) {
                    coberturaInvalidez = (qtdStepsValorAtual + 1) * stepInvalidez
                } else {
                    qtdSteps = Math.trunc(dif / stepInvalidez)
                    coberturaInvalidez = (qtdStepsValorAtual + qtdSteps + 1) * stepInvalidez
                }
            }

            coberturaTotal = coberturaMorte > coberturaInvalidez ? coberturaMorte : coberturaInvalidez
            return [this.valorFormatoDesc(coberturaTotal), coberturaTotal] //, coberturaMorte, coberturaInvalidez]
        }
    },
    calculaProRata(valor, dataInicial, dataFinal, taxa) {
        //dataFinal = new Date(2021, 3, 30)
        let diaMesFinal = dataFinal.getDate()
        let qtdDiasProrata = utils.diffDatasEmDias(dataInicial, dataFinal) + 1

        //calcula valor do principal considerando o prorata até o final do mês da solicitação
        return valor * Math.pow(1 + (taxa / 100), (qtdDiasProrata / diaMesFinal))

    },
    geraCurvaGraficoProjetoVida(valorInicial, valorFinal, valorAtual, qtdPontos, labelUltimoPeriodo) {
        //usa modelo de cálculo da Curva de Bézier Quadrática - B(t) = (1 - t)²B0 + 2t(1-t)B1 + t²B2 - sendo t entre 0 e 1
        const fator = 1 / qtdPontos
        const valorMeioCurva = (valorAtual - valorInicial) / 2
        let curvaCompleta = [], curvaAteHoje = [], posHoje = 0, t = 0, finalizaHoje = false, mesesProjetoVida = []
        for (let i = 0; i <= (qtdPontos - 1); i++) {
            let valorPontoCurva = (Math.pow((1 - t), 2) * valorInicial) + ((2 * t) * (1 - t) * valorMeioCurva) + (Math.pow(t, 2) * valorFinal)
            curvaCompleta.push(valorPontoCurva)
            mesesProjetoVida.push("")
            if (valorPontoCurva <= valorAtual) {
                posHoje = i
                curvaAteHoje.push(valorPontoCurva)
                finalizaHoje = true
            } else if (finalizaHoje) { //inclui mais um item na curva até hoje
                posHoje = i
                curvaAteHoje.push(valorPontoCurva)
                finalizaHoje = false
                mesesProjetoVida[mesesProjetoVida.length - 1] = 'Hoje'
            }

            t += fator
        }
        mesesProjetoVida[mesesProjetoVida.length - 1] = labelUltimoPeriodo || '65 anos'
        return {
            curvaCompleta: curvaCompleta,
            curvaAteHoje: curvaAteHoje,
            mesesProjetoVida: mesesProjetoVida,
            posHoje: posHoje
        }
    }
}
